import { isWeb, isPhone } from '@helpers';
import { fullWidth } from '@components/frame';

export const parseFacetsToStorage = (facets: Record<string, any> | null): Record<string, number> => {
  const storage: Record<string, number> = {};
  if (facets) {
    Object.values(facets).forEach((v: any) => {
      if (Array.isArray(v)) {
        v.forEach((i: any) => {
          storage[i.value] = i.count;
        });
      }
    });
  }
  return storage;
};

export const calculateElementWidth = ({
  filtersCount,
  gap,
  style,
  availableWidth,
  scale,
}: {
  filtersCount: number;
  gap: number;
  style?: any;
  availableWidth?: number;
  scale: (v: number) => number;
}): number => {
  const widthPassed = style && style?.width != null;
  const baseWidth = availableWidth || fullWidth;
  const horizontalPadding = scale(36);
  const calculatedWidth =
    ((widthPassed ? style.width : baseWidth) - (widthPassed ? 0 : horizontalPadding) - (filtersCount - 1) * gap) / filtersCount;

  if (isWeb) return calculatedWidth;
  if (isPhone) return Math.max(120, calculatedWidth);
  if (widthPassed) return calculatedWidth;
  return Math.max(200, calculatedWidth);
};
